export const MAILCHIMP_ROUTE_NAMES = {
  TEMPLATE_EDIT: 'templateEdit',
}
